import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col, Card, Table, Button, Form } from 'react-bootstrap';

import { ASYNC_USER_LOGOUT } from 'store';
import *  as logoLight from "../../images/logo-light.png"
import *  as logoSm from "../../images/logo-sm.png"
import history from '../history';
import style from './style.module.scss';

import './style.css';
import LoginService from 'services/login';

const Header = ({collapsed}) => {

  const [ isUserBoxOpen, setOpenUserBox  ] = useState('hide');

  const getUsername = () => {
      return localStorage.getItem("username");
  }

  const getCompanyName = () =>{
    return localStorage.getItem('companyId')!=null?
    (
    <li className={style.vendorName+" align-middle"}>
      <p style={{color:'black'}}>
        <strong>Nome do cliente:<br/></strong>
        <span>{localStorage.getItem('companyName')}<br/></span>
        <Button
          className={"btn-secondary "+style.btnSecondaryGrey+" waves-effect btn-xs"}
          size="sm"
          onClick={()=>{
            localStorage.removeItem('companyId');
            localStorage.removeItem('companyName');
            window.location.href = window.location.href;
          }}>Voltar</Button>
      </p>
    </li>
    ):<></>;
  }

  const openUserBox = () => {
    setOpenUserBox(isUserBoxOpen === 'show' ? 'hide' : 'show');
  }

  const logout = async () => {
    await LoginService.logout();
    localStorage.clear();
    return history.push("login");
  };


  useEffect( () => {

  }, [isUserBoxOpen]);

  return (
    <div className={"navbar-custom"+(!!collapsed?' collapsed':'')}>
      <ul className="list-unstyled topnav-menu float-right mb-0">
        {getCompanyName()}
        <li className="dropdown notification-list">
          <a className="nav-link dropdown-toggle nav-user mr-0 waves-effect waves-light" data-toggle="dropdown" href="#"
             role="button" aria-haspopup="false" aria-expanded="false" onClick={openUserBox}>
              <span className="pro-user-name ml-1">
                { getUsername() } 
                <i className="mdi mdi-chevron-down"></i>
              </span>
          </a>

          <ul className={`dropdown-menu dropdown-menu-right profile-dropdown ${isUserBoxOpen}`}>
            <li className="dropdown-header noti-title">
              <h6 className="text-overflow m-0">Bem Vindo</h6>
            </li>
            <a href="#" className="dropdown-item notify-item" onClick={logout}>
              <i className="fe-log-out"></i>
              <span> Logout </span>
            </a>
          </ul>

        </li>

      </ul>
    </div>
  );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch({ type: ASYNC_USER_LOGOUT })
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
